import React, { FunctionComponent } from "react";
import { Claim } from "../../../../types";
import "../DetailView.css";
import Financials from "../financials/Financials";
import ProjectManager from "../project-manager/ProjectManager";
import ProjectCoordinator from "../project-coordinator/ProjectCoordinator";
import BaseDetails from "../base-details/BaseDetails";

type OverviewProps = {
  dataSelected: Claim;
};
const Overview: FunctionComponent<OverviewProps> = (props) => {
  const { dataSelected } = props;

  return (
    <>
      <BaseDetails dataSelected={dataSelected} />
      <Financials dataSelected={dataSelected} />
      <ProjectManager dataSelected={dataSelected} />
      <ProjectCoordinator dataSelected={dataSelected} />
    </>
  );
};

export default Overview;
